import createSelectors from './createSelectors';
import AuditLog from '../models/AuditLog';

const Select = createSelectors(AuditLog, {});

export default Select;
